export default {"src":"/_next/static/media/neo.dbd80dcc.svg","height":38,"width":95};